import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
	FiPlus,
	FiSearch,
	FiRefreshCcw,
	FiDownload,
	FiMoreHorizontal,
} from 'react-icons/fi';
import { FormGroup, FormControl, Dropdown, FormLabel } from 'react-bootstrap';
import Loading from 'components/Loading';
import Layout from 'components/Layout';
import Switch from 'components/Switch';
import ShiftPatternsList from 'components/ShiftPatterns';
import ShiftPatternEditModal from 'components/ShiftPatterns/ShiftPatternEditModal';
import { showModal, hideModal } from 'actions/modalActions';
import * as shiftsActions from 'actions/shiftsActions';
import * as ubicationsActions from 'actions/ubicationsActions';
import Modal from 'components/Modal';
import { helpUrls } from 'utils/helpUrls';
import { withTranslation } from 'react-i18next';
import HelpBanner from 'components/HelpBanner';
import { canEditShiftPatterns, isAdmin } from 'utils/utils';

class ShiftPatterns extends Component {
	constructor(props) {
		super(props);

		this.state = {
			active_only: true,
			search_shift_pattern: '',
		};

		// console.log(props);
		this.closeModal = this.closeModal.bind(this);
		this.openNewShiftPatternModal = this.openNewShiftPatternModal.bind(this);
		this.getShiftPatterns = this.getShiftPatterns.bind(this);
	}

	componentDidMount() {
		this.getShiftPatterns();
		this.props.getSelectableShifts();
		this.props.getSelectableUbications();
		this.props.getShiftTypes();
		this.props.getDefaultShift();
	}

	handleChangeSearch = (event) => {
		const targetId = event.target.id;

		this.setState(
			{
				[targetId]:
					targetId === "active_only"
						? event.target.checked
						: event.target.value,
			},
			() => {
				if (targetId === "search_shift_pattern") {
					clearTimeout(this.timer);
					this.timer = setTimeout(() => {
						this.getShiftPatterns();
					}, 500);
				} else {
					this.getShiftPatterns();
				}
			}
		);
	};

	async getShiftPatterns() {
		await this.props.getAllShiftPatterns({
			q: this.state.search_shift_pattern,
			enabled: this.state.active_only,
			variant: 'detailed',
		});
	}

	closeModal() {
		this.props.hideModal();
	}

	openNewShiftPatternModal() {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('shiftPatterns.newShiftPattern'),
				style: { width: '980px', maxWidth: 'calc(100vw - 32px)' },
				content: (
					<ShiftPatternEditModal
						getShiftPatterns={this.getShiftPatterns}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			'edit'
		);
	}

	getContent = () => {
		if (this.props.loading_shift_patterns) {
			return <Loading />;
		}

		if (this.props.error_shift_patterns) {
			return (
				this.props.t('shiftPatterns.errorLoading') + ': ' +
				this.props.error_shift_patterns
			);
		}

		if (!this.props.shift_patterns) {
			return this.props.t('shiftPatterns.errorLoading');
		}

		if (this.props.shift_patterns.length == 0) {
			return (
				<div className="first-steps">
					<FiRefreshCcw className="icono-pasos" />
					<h3 className="title2">{this.props.t('shiftPatterns.firstSteps.title')}</h3>

					<p>
						{this.props.t('shiftPatterns.firstSteps.description')}{' '}
						<a className="alink" target="_blank" href={helpUrls.shift_pattern}>
							{helpUrls.shift_pattern}
						</a>
					</p>
				</div>
			);
		}

		return (
			<ShiftPatternsList
				getShiftPatterns={this.getShiftPatterns}
				shift_patterns={this.props.shift_patterns}
				canEdit={this.props.canEditShiftPatterns}
			/>
		);
	};

	render() {
		const { active_only, search_shift_pattern } = this.state;
		const { canEditShiftPatterns: canEdit } = this.props;

		return (
			<>
				<Layout
					configSidebar={true}
					className="page-shift-patterns"
					context="shifts"
				>
					<div className="heading">
						<h1 className="title">{this.props.t('shiftPatterns.title')}</h1>
						<div className="heading-help-banner heading-config hidden-sm">
							<HelpBanner
								title={this.props.t('common.needHelp')}
								// text="Encuentra todo en un solo lugar."
								linkText={this.props.t('common.moreInfo')}
								linkHref={helpUrls.shift_pattern}
							/>
						</div>

						<div className="heading-filters">
							<FormGroup
								className="form-group form-group-flex form-switch"
								controlId="active_only"
							>
								<Switch
									controlId="active_only"
									isOn={active_only}
									handleToggle={this.handleChangeSearch}
								/>
								<FormLabel>{this.props.t('common.showActive')}</FormLabel>
							</FormGroup>

							<FormGroup
								className="form-group form-search"
								controlId="search_shift_pattern"
							>
								<FormControl
									type="text"
									placeholder={this.props.t('common.searchPlaceholder')}
									value={search_shift_pattern}
									onChange={this.handleChangeSearch}
								/>
								<FiSearch />
							</FormGroup>
						</div>

						<div className="heading-actions">
							{canEdit && (
								<button
									type="button"
									title={this.props.t('shiftPatterns.createShiftPattern')}
									onClick={this.openNewShiftPatternModal}
									className="btn btn-new"
								>
									<FiPlus />
								</button>
							)}

							{canEdit && isAdmin() && (
								<Dropdown>
								<Dropdown.Toggle variant="action">
									<FiMoreHorizontal />
								</Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Item
										as="button"
										onClick={() =>
											this.props.history.push('/shift-patterns/import')
										}
									>
										<FiDownload className="dropdown-icon" /> {this.props.t('shiftPatterns.importShiftPattern')}
									</Dropdown.Item>
									<Dropdown.Item
										as="button"
										onClick={() =>
											this.props.history.push(
												'/employees/shift-patterns/import'
											)
										}
									>
										<FiDownload className="dropdown-icon" /> {this.props.t('shiftPatterns.importAssignments')}
									</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
							)}
						</div>
					</div>

					{this.getContent()}
				</Layout>

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.shiftsReducer,
		...reducers.ubicationsReducer,
		loading: reducers.shiftsReducer.loading,
		loading_shift_patterns: reducers.shiftsReducer.loading_shift_patterns,
		error_shift_patterns: reducers.shiftsReducer.error_shift_patterns,
		canEditShiftPatterns: canEditShiftPatterns(reducers.authReducer.user),
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getAllShiftPatterns: (options) =>
		dispatch(shiftsActions.getAllShiftPatterns(options)),
	getShiftTypes: () => dispatch(shiftsActions.getShiftTypes()),
	getSelectableShifts: () => dispatch(shiftsActions.getSelectableShifts()),
	getSelectableUbications: (options) =>
		dispatch(ubicationsActions.getSelectableUbications(options)),
	getAllShifts: (options) => dispatch(shiftsActions.getAllShifts(options)),
	getDefaultShift: () => dispatch(shiftsActions.getDefaultShift()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ShiftPatterns));
